export default __webpack_public_path__ + "static/media/groceryBag_img.bbb5b992.png";